(function () {
    'use strict';

    angular.module("imApp").factory("poFinishProdCompsBService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 173,
                    parameters: parms || {}
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 174,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
